/* UnuDerm+ product page behaviour — gallery, variants, subscription, tabs, carousels */
(function () {
  if (window.__unuInit) return;
  window.__unuInit = true;

  function money(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents, format); } catch (e) {}
    }
    var value = (cents / 100).toFixed(2).replace(/\.00$/, '');
    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || 'Rs. {{amount}}').replace(/\{\{\s*[a-z_]+\s*\}\}/, value);
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = root.querySelector('.unu-gallery__track');
    if (!track) return;
    var slides = track.children;
    var dots = root.querySelectorAll('.unu-dots button');
    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function sync() {
      var c = current();
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === c ? 'true' : 'false'); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    root.__goToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaId === String(mediaId)) { go(i); return; }
      }
    };
    sync();
  }

  /* ---------- Product form ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-unu-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var format = root.dataset.moneyFormat;
    var form = root.querySelector('form.unu-form');
    var idInput = form.querySelector('input[name="id"]');
    var planInput = form.querySelector('input[name="selling_plan"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var atc = form.querySelector('[data-atc]');
    var atcPrice = form.querySelector('[data-atc-price]');
    var atcLabel = form.querySelector('[data-atc-label]');
    var onePrice = root.querySelector('[data-one-price]');
    var subPrice = root.querySelector('[data-sub-price]');
    var subCompare = root.querySelector('[data-sub-compare]');
    var freqSelect = root.querySelector('[data-sub-frequency]');
    var modeInputs = root.querySelectorAll('input[name="unu-purchase-mode"]');
    var gallery = root.querySelector('.unu-gallery');

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('.unu-pills'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function findVariant() {
      var opts = selectedOptions();
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || opts[i] === o; });
      });
    }
    function mode() {
      var m = root.querySelector('input[name="unu-purchase-mode"]:checked');
      return m ? m.value : 'once';
    }
    function planAllocation(variant) {
      if (!freqSelect || !variant) return null;
      var planId = Number(freqSelect.value);
      return (variant.selling_plan_allocations || []).find(function (a) { return a.selling_plan_id === planId; }) || null;
    }
    function update(pushUrl) {
      var v = findVariant();
      var sub = mode() === 'subscribe';
      root.querySelectorAll('.unu-opt').forEach(function (el) {
        el.classList.toggle('is-active', !!el.querySelector('input[name="unu-purchase-mode"]:checked'));
      });
      if (!v) {
        atc.disabled = true;
        atcLabel.textContent = atc.dataset.unavailable;
        atcPrice.textContent = '';
        return;
      }
      idInput.value = v.id;
      var alloc = planAllocation(v);
      var price = v.price;
      if (onePrice) onePrice.textContent = money(v.price, format);
      if (subPrice) {
        subPrice.textContent = money(alloc ? alloc.price : v.price, format);
        if (subCompare) subCompare.textContent = alloc && alloc.price < v.price ? money(v.price, format) : '';
      }
      if (sub && alloc) {
        price = alloc.price;
        if (planInput) { planInput.value = alloc.selling_plan_id; planInput.disabled = false; }
      } else if (planInput) {
        planInput.value = ''; planInput.disabled = true;
      }
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? atc.dataset.label : atc.dataset.soldout;
      atcPrice.textContent = v.available ? money(price * qty, format) : '';
      atc.querySelector('.unu-btn__sep').hidden = !v.available;
      if (v.featured_media && gallery && gallery.__goToMedia) gallery.__goToMedia(v.featured_media.id);
      if (pushUrl && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('.unu-pills input').forEach(function (i) { i.addEventListener('change', function () { update(true); }); });
    modeInputs.forEach(function (i) { i.addEventListener('change', function () { update(false); }); });
    if (freqSelect) freqSelect.addEventListener('change', function () {
      var s = root.querySelector('input[name="unu-purchase-mode"][value="subscribe"]');
      if (s) s.checked = true;
      update(false);
    });
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.qty);
        qtyInput.value = Math.max(1, n);
        update(false);
      });
    });
    qtyInput.addEventListener('change', function () { update(false); });
    update(false);
  }

  /* ---------- Horizontal carousels ---------- */
  function initCarousels(scope) {
    scope.querySelectorAll('[data-unu-carousel]').forEach(function (c) {
      if (c.__unu) return; c.__unu = true;
      c.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var track = c.querySelector('.unu-carousel__track:not([hidden])');
          if (!track) return;
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
          track.scrollBy({ left: step * Number(b.dataset.dir), behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- Tabs (generic) ---------- */
  function initTabs(scope) {
    scope.querySelectorAll('[data-unu-tabs]').forEach(function (group) {
      if (group.__unu) return; group.__unu = true;
      var tabs = group.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            var panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
        });
      });
    });
  }

  /* ---------- Clinical before/after thumbs ---------- */
  function initClinical(scope) {
    scope.querySelectorAll('.unu-clinical__media').forEach(function (m) {
      if (m.__unu) return; m.__unu = true;
      var imgs = m.querySelectorAll('.unu-clinical__main img');
      var thumbs = m.querySelectorAll('.unu-clinical__thumbs button');
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x, j) { x.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
          imgs.forEach(function (img, j) { img.hidden = i !== j; });
        });
      });
    });
  }

  /* ---------- Recommendations + recently viewed ---------- */
  var RV_KEY = 'unu_recently_viewed';
  function readRV() { try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; } }
  function writeRV(list) { try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {} }

  function initRecs(scope) {
    scope.querySelectorAll('.unu-recs[data-url]').forEach(function (sec) {
      if (sec.__unu) return; sec.__unu = true;
      var handle = sec.dataset.handle;
      var rv = readRV().filter(function (h) { return h !== handle; });
      writeRV([handle].concat(rv).slice(0, 12));

      var recTrack = sec.querySelector('[data-recs-track]');
      if (recTrack && !recTrack.children.length) {
        fetch(sec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recs-track]');
          if (fresh && fresh.children.length) recTrack.innerHTML = fresh.innerHTML;
          else recTrack.outerHTML = '<p class="unu-recs__empty">' + sec.dataset.emptyText + '</p>';
        }).catch(function () {});
      }

      var rvTrack = sec.querySelector('[data-rv-track]');
      if (rvTrack && rv.length) {
        var fmt = sec.dataset.moneyFormat;
        Promise.all(rv.slice(0, 8).map(function (h) {
          return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (items) {
          var html = items.filter(Boolean).map(function (p) {
            var img = p.featured_image ? '<img src="' + p.featured_image + '&width=500" alt="" loading="lazy">' : '';
            var cmp = p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price, fmt) + '</s>' : '';
            return '<div class="unu-card"><a class="unu-card__media" href="' + p.url + '">' + img + '</a>' +
              '<div class="unu-card__body"><div class="unu-card__meta"><a class="unu-card__title" href="' + p.url + '">' + p.title + '</a>' +
              '<span class="unu-card__price">' + cmp + money(p.price, fmt) + '</span></div></div></div>';
          }).join('');
          if (html) rvTrack.innerHTML = html;
        });
      }
    });
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('.unu-gallery').forEach(initGallery);
    scope.querySelectorAll('[data-unu-product]').forEach(initProduct);
    initCarousels(scope); initTabs(scope); initClinical(scope); initRecs(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
